import { render, staticRenderFns } from "./ErrorText.vue?vue&type=template&id=3e2553d6"
import script from "./ErrorText.vue?vue&type=script&lang=ts"
export * from "./ErrorText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports